import _ from 'lodash'
import jose from 'node-jose'
import { store } from '../../src/store/store'

let userAccessJwt
const jwtVerification = {

  /**
   * This method verifies the jwt against the public keys
   * @param jwt
   * @param srcKeys
   * @returns {Promise<unknown>}
   */
  verifyJwtKey (jwt, srcKeys) {
    let keystore
    userAccessJwt = jwt
    let jwtSignature = userAccessJwt.includes('.') ? (userAccessJwt).split('.')[0] : userAccessJwt
    let headerData = JSON.parse(atob(jwtSignature))
    let webKey = ''
    _.forEach(srcKeys, srcKey => {
      if (srcKey.kid.includes(headerData.kid)) {
        webKey = srcKey
      }
    })
    var identityVerificationKey = [{
      'kty': webKey.kty,
      'e': webKey.e,
      'use': webKey.use,
      'kid': webKey.kid,
      'key_ops': [
        webKey.key_ops
      ],
      'alg': webKey.alg,
      'n': webKey.n
    }]
    return new Promise(function (resolve, reject) {
      jose.JWK.asKeyStore(identityVerificationKey)
        .then(function (result) {
          keystore = result
          jose.JWS.createVerify(keystore).verify(userAccessJwt).then(function (jwtResult) {
            if (jwtResult) {
              resolve()
            }
          }).catch(err => {
            console.error(err)
            reject()
          })
        })
    })
  },

  /**
   * This method return the jwt expiry time
   * @returns {*}
   */
  validateJwtExpiry () {
    let storeAccessJwt = (store.state.configuration.userAccessToken || {}).startAccessJwt
    let accessJwt = userAccessJwt || storeAccessJwt
    if (accessJwt) {
      let jwtSignature = (accessJwt).split('.')[1]
      let payloadData = JSON.parse(atob(jwtSignature))
      return payloadData.exp
    }
  }
}

export default jwtVerification
